var _style, _path, _path2, _linearGradient, _path3, _linearGradient2, _path4, _path5, _ellipse, _linearGradient3, _path6, _ellipse2, _path7, _linearGradient4, _path8, _path9, _linearGradient5, _path10, _linearGradient6, _path11, _radialGradient, _circle, _radialGradient2, _circle2, _path12, _path13, _path14, _linearGradient7, _path15, _linearGradient8, _path16, _linearGradient9, _path17, _path18, _path19, _ellipse3, _ellipse4, _linearGradient10, _path20, _path21, _linearGradient11, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParticipants(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#5a4f51}.st1{fill:#fcbda7}.st10{fill:none;stroke:#5a4f51;stroke-width:6;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311 241.5s-8.6 24.2 0 39.2c8.6 15.1-8.6 24.7-9.1 43.9s7.1 25.3 19.8 28.4c12.7 3.1 116.3 19.8 126.8 0s4.2-32.4 0-52.7c-4.2-20.3 10.5-16.7 11.4-45.6s-11.2-20.8-18.2-32.9c-7-12.2-119.5-3.8-119.5-3.8L311 241.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M401 321.4v-40.7h-43v40.7c-110.6 48.3-97.8 85.1-97.8 85.1h238.5c.1 0 13-36.9-97.7-85.1z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 377.629,
    y1: -95.817,
    x2: 377.629,
    y2: 48.532,
    gradientTransform: "matrix(1 0 0 -1 0 217.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcab81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fcad86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fdbda7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fec8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ffcfcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd1d1"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M435.3 241.5c0 21.8-8.2 46.4-26.5 60.8-4.1 3.1-15.7 12-31.1 11.4-28.2-1.1-57.6-33.6-57.6-72.2 0-39.9 25.8-72.2 57.6-72.2s57.6 32.3 57.6 72.2z",
    fill: "url(#SVGID_1_)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 433.545,
    y1: 523.818,
    x2: 445.631,
    y2: 523.818,
    gradientTransform: "translate(0 -281.96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#fec8be"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M445.6 241.9c0 4.1-.9 8.8-2.8 11.5-.4.6-1.6 2.3-3.3 2.2-2.9-.2-6-6.4-6-13.7 0-7.6 2.7-13.7 6-13.7 3.4-.1 6.1 6.2 6.1 13.7z",
    fill: "url(#SVGID_2_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M356.1 195.5s50.1 40 83 32.6-29.5-80.6-65.1-74.9-73 43.7-63 88.2c0 .1 39.1-39 45.1-45.9z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 405,
    cy: 241.5,
    rx: 2.6,
    ry: 5.2
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.275,
    y1: 526.555,
    x2: 320.361,
    y2: 526.555,
    gradientTransform: "translate(0 -281.96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#fec8be"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M320.4 244.6c0 4.1-.9 8.8-2.8 11.5-.4.6-1.6 2.3-3.3 2.2-2.9-.2-6-6.4-6-13.7 0-7.6 2.7-13.7 6-13.7 3.4 0 6.1 6.2 6.1 13.7z",
    fill: "url(#SVGID_3_)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 351.4,
    cy: 241.6,
    rx: 2.6,
    ry: 5.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.5 322.4v-36.1h-40v36.1C-4.2 365.3 7.8 398 7.8 398h221.5s12-32.7-90.8-75.6z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.496,
    y1: -83.634,
    x2: 114.496,
    y2: 79.629,
    gradientTransform: "matrix(1 0 0 -1 0 217.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcab81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fcad86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fdbda7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fec8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ffcfcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd1d1"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M179.7 219.8c0 24.6-9.2 52.5-30 68.7-4.6 3.6-17.8 13.6-35.2 12.9-31.9-1.2-65.2-38-65.2-81.6 0-45.1 29.2-81.6 65.2-81.6s65.2 36.6 65.2 81.6z",
    fill: "url(#SVGID_4_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.4 334.7v71.8h69.7s10.5-30.3-69.7-71.8zM136.8 176.7s-49.2 40-81.5 32.6 29-80.6 63.9-74.9c34.9 5.7 71.7 43.7 61.8 88.2 0 .1-38.2-39-44.2-45.9z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 178.126,
    y1: 505.223,
    x2: 191.777,
    y2: 505.223,
    gradientTransform: "translate(0 -281.96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#fec8be"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M191.8 223.2c0 4.7-1 10-3.1 13.1-.5.7-1.8 2.6-3.7 2.5-3.3-.2-6.8-7.2-6.8-15.5 0-8.6 3.1-15.5 6.8-15.5 3.7 0 6.8 6.8 6.8 15.4z",
    fill: "url(#SVGID_5_)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.425,
    y1: 505.404,
    x2: 52.075,
    y2: 505.404,
    gradientTransform: "translate(0 -281.96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#fec8be"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1 223.4c0 4.7-1 10-3.1 13.1-.5.7-1.8 2.6-3.7 2.5-3.3-.2-6.8-7.2-6.8-15.5 0-8.6 3.1-15.5 6.8-15.5s6.8 6.8 6.8 15.4z",
    fill: "url(#SVGID_6_)"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: 90.182,
    cy: -9.908,
    r: 20.66,
    gradientTransform: "matrix(1 0 0 -1 0 217.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90.2,
    cy: 227.8,
    r: 20.7,
    fill: "url(#SVGID_7_)",
    stroke: "#5a4f51",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 144.498,
    cy: 506.078,
    r: 20.66,
    gradientTransform: "translate(0 -281.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 227.4,
    r: 20.7,
    fill: "url(#SVGID_8_)",
    stroke: "#5a4f51",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M49.4 213.9l16.8 9.5h3.3M110.8 227.8s5.5-7.2 13-.4M165.1 227.4l15.9-13.5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176 108.9s-2.2-61.1 53.7-64"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.2 287v-56.2h-62.1V287C64.4 353.6 83 404.4 83 404.4h344.5c-.1 0 18.5-50.7-141.3-117.4z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 332.238,
    y1: 451.904,
    x2: 349.585,
    y2: 451.904,
    gradientTransform: "translate(0 -281.96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#fec8be"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M349.6 169.9c0 6-1.2 12.7-4 16.7-.6.9-2.3 3.3-4.7 3.1-4.3-.3-8.7-9.2-8.7-19.8 0-10.9 3.9-19.8 8.7-19.8s8.7 8.9 8.7 19.8z",
    fill: "url(#SVGID_9_)"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.976,
    y1: -54.674,
    x2: 250.976,
    y2: 153.817,
    gradientTransform: "matrix(1 0 0 -1 0 217.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcab81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fcad86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fdbda7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fec8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ffcfcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd1d1"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M334.2 168.3c0 31.4-11.7 67-38.2 87.7-5.8 4.5-22.8 17.3-44.9 16.5-40.7-1.6-83.2-48.4-83.2-104.2 0-57.6 37.3-104.2 83.2-104.2s83.1 46.6 83.1 104.2z",
    fill: "url(#SVGID_10_)"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.078,
    y1: 452.615,
    x2: 170.426,
    y2: 452.615,
    gradientTransform: "translate(0 -281.96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#fec8be"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M170.4 170.6c0 6-1.2 12.7-4 16.7-.6.9-2.3 3.3-4.7 3.1-4.3-.3-8.7-9.2-8.7-19.8 0-10.9 3.9-19.8 8.7-19.8 4.8 0 8.7 9 8.7 19.8z",
    fill: "url(#SVGID_11_)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.9 45.4c-2-.4-4.1-.5-6.1-.4v44.2c28.3-.8 57 7.4 57 7.4 7.5 9.9 27.3 76.3 27.3 76.3 12.5-64.4-34-119.3-78.2-127.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.4 45.4c2-.4 3.9-.5 5.9-.5v44.2c-27.4-.8-55.2 7.4-55.2 7.4-7.3 9.9-26.4 76.3-26.4 76.3-12.1-64.3 32.9-119.2 75.7-127.4z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 288.3,
    cy: 162,
    rx: 5.2,
    ry: 10.4
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 217.7,
    cy: 161.3,
    rx: 5.2,
    ry: 10.4
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 500,
    y1: 386.359,
    x2: 267.02,
    y2: 386.359
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1647c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8c7ac"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M499.9 404.4c.7-8.3-1.8-39.3-69.7-79.7-13.3 11.2-29.5 17.8-47 17.8s-33.6-6.5-46.8-17.6c-79.3 47.3-69 81.7-69 81.7h.2V448H500l-.1-43.6z",
    fill: "url(#SVGID_12_)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.3 448v-81.8c-19.6 5.7-39.6 4.8-58.7-.7V335C-10 376.5.5 406.6.5 406.6V448h127.8z"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.646,
    y1: 375.42,
    x2: 428.145,
    y2: 375.42
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdffc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd181"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M427.4 403.4c.5-12.5-7-51-103.6-100.5-41.4 30.4-97.7 30.5-139.1.3-96 49.3-103.5 87.7-103 100.2V448h346.5v-44.6h-.8z",
    fill: "url(#SVGID_13_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipants);
export default __webpack_public_path__ + "static/media/participants.f657047b57f34b0398c8525cc963ef12.svg";
export { ForwardRef as ReactComponent };